import React, { useState, useEffect } from 'react';

interface TypewriterTextProps {
    text: string;
    speed?: number; // ms per char
    onComplete?: () => void;
    renderText: (text: string) => React.ReactNode;
}

export const TypewriterText: React.FC<TypewriterTextProps> = ({
    text: fullText,
    speed = 10,
    onComplete,
    renderText
}) => {
    const [displayedText, setDisplayedText] = useState('');
    const [isComplete, setIsComplete] = useState(false);

    useEffect(() => {
        // Reset
        setDisplayedText('');
        setIsComplete(false);

        // Instant mode
        if (speed === 0 || !fullText) {
            setDisplayedText(fullText);
            setIsComplete(true);
            onComplete?.();
            return;
        }

        let currentLength = 0;
        const totalLength = fullText.length;

        const timer = setInterval(() => {
            currentLength++;
            if (currentLength <= totalLength) {
                setDisplayedText(fullText.slice(0, currentLength));
            }

            if (currentLength >= totalLength) {
                clearInterval(timer);
                setIsComplete(true);
                onComplete?.();
            }
        }, speed);

        return () => clearInterval(timer);
    }, [fullText, speed]);

    // Use the caller's render function (to handle bolding/links) on the sliced text
    return <>{renderText(displayedText)}</>;
};
